import { Component, input, computed, inject, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { I18nService } from '../../services/i18n.service';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { SanitizeInputPipe } from '../../pipes/sanitize-input-pipe';

@Component({
  selector: 'app-input-label',
  templateUrl: './input-label.html',
  styleUrls: ['./input-label.scss'],
  imports: [FormsModule, NzInputModule, NzFormModule, SanitizeInputPipe],
})
export class InputLabelComponent {
  label = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  key = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  value = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);

  optional = input<boolean | null>(false);
  required = input<boolean | null>(false);

  onchange = output<string>();
  public i18n = inject(I18nService);
  private touched = signal(false);
  readonly displayLabel = computed(() =>
    this.optional() ? `${this.label()} (${this.i18n.langString('optional')})` : this.label()
  );
  readonly isInvalid = computed(() => this.required() && this.touched() && !this.value()?.trim());
  onInputChange(value: string): void {
    this.touched.set(true);
    this.onchange.emit(value);
  }
}
